import axios from 'axios'
import { host } from '../../configuraciones'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'


const dataInicial = {
    trazabilidad: []
}

//DEFINICIÓN DE MÉTODOS *********************************************************************************************

const GET_ALL_LOTES_PRODUCCION = 'GET_ALL_LOTES_PRODUCCION'
const GET_ALL_LOTES_GRANEL_FABRICA = 'GET_ALL_LOTES_GRANEL_FABRICA'
const GET_ALL_LOTES_GRANEL_ENVASADO = 'GET_ALL_LOTES_GRANEL_ENVASADO'
const GET_ALL_LOTES_ENVASADO = 'GET_ALL_LOTES_ENVASADO'

//*******************************************************************************************************************


//METODOS
export const obtenerLotesProduccion = createAsyncThunk(
    GET_ALL_LOTES_PRODUCCION,
    async (nocliente) => {
        try {
            const fullUrl = `https://ralew.com.mx/syscrm/backend/api/cliente/trazabilidad/getlstLotesproduccion/${nocliente}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerLotesGranelFabrica = createAsyncThunk(
    GET_ALL_LOTES_GRANEL_FABRICA,
    async (nocliente) => {
        try {
            const fullUrl = `https://ralew.com.mx/syscrm/backend/api/cliente/trazabilidad/getlstLotesGranelFabrica/${nocliente}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerLotesGranelEnvasado = createAsyncThunk(
    GET_ALL_LOTES_GRANEL_ENVASADO,
    async (nocliente) => {
        try {
            const fullUrl = `https://ralew.com.mx/syscrm/backend/api/cliente/trazabilidad/getlstLotesEnvasado/${nocliente}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)

export const obtenerLotesEnvasado = createAsyncThunk(
    GET_ALL_LOTES_ENVASADO,
    async (nocliente) => {
        try {
            const fullUrl = `https://ralew.com.mx/syscrm/backend/api/cliente/trazabilidad/getlstLotesEnvasado/${nocliente}`
            const res = await axios.get(fullUrl)
            return res
        } catch (error) {
            console.log(error);
        }
    }
)


//****************************************************************************************************************
//EXPORTS DE MÉTODOS

export const metodosTrazabilidad = createSlice({

    name: 'metodosTrazabilidad',
    initialState: dataInicial,
    reducers: {
    },
    extraReducers: {
        [obtenerLotesProduccion.fulfilled]: (state, { payload }) => {
            state.trazabilidad = payload.data.data
        },
        [obtenerLotesGranelFabrica.fulfilled]: (state, { payload }) => {
            state.trazabilidad = payload.data.data
        },
        [obtenerLotesGranelEnvasado.fulfilled]: (state, { payload }) => {
            state.trazabilidad = payload.data.data
        },
        [obtenerLotesEnvasado.fulfilled]: (state, { payload }) => {
            state.trazabilidad = payload.data.data
        },
    },

})

export const { } = metodosTrazabilidad.actions
export const TrazabilidadReducer = metodosTrazabilidad.reducer